module.exports = __webpack_public_path__ + "img/5.c6c38fcc.png";